import {
    BaseComponentProps,
    createComponentBase,
} from "../../../../libs/components";
import { Input } from "../../../atoms/input";
import { MultipleFileUpload } from "../../../atoms/multipleFileUpload";
import { RichTextEditor } from "../../../atoms/richTextEditor";

export interface OthersRequestProps extends BaseComponentProps {
    payload: any;
    setPayload: any;
}

export const OthersRequest = ({
    className,
    payload,
    setPayload,
}: OthersRequestProps) => {
    const componentClassName = "o-saas-tool-configuration-request";
    const { Container } = createComponentBase(componentClassName, "div");
    const modifiers = {};

    return (
        <Container className={className} modifiers={modifiers}>
            <div className={`${componentClassName}__form`}>
                <div className={`${componentClassName}__form__items`}>
                    <Input
                        value={payload?.saasTool?.value?.issue_summary}
                        label="Issue Summary"
                        placeholder="Please enter issue summary"
                        className={`${componentClassName}__form__item__input`}
                        onChange={(e) =>
                            setPayload({
                                ...payload,
                                saas_tool: {
                                    value: {
                                        ...payload.saas_tool.value,
                                        issue_summary: e.target.value,
                                    },
                                },
                            })
                        }
                        isRequired
                        isStar
                    />

                    <RichTextEditor
                        label="Issue Description"
                        className={`${componentClassName}__form__item__editor`}
                        value={payload?.saasTool?.value?.instruction}
                        placeholder="Please enter issue description"
                        onChanged={(val) =>
                            setPayload({
                                ...payload,
                                saas_tool: {
                                    value: {
                                        ...payload.saas_tool.value,
                                        instruction: val,
                                    },
                                },
                            })
                        }
                    />

                    <div className={`${componentClassName}__form__item`}>
                        <label className={`${componentClassName}__form___label`}>
                            Attachments
                        </label>
                        <MultipleFileUpload
                            onUpload={(files) => {
                                setPayload({
                                    ...payload,
                                    attachments: {
                                        value: files as File[],
                                    },
                                });
                            }}
                            placeholder="Please select attachments"
                            isError={payload?.attachments?.isError}
                            error={payload?.attachments?.error}
                        />
                    </div>
                </div>
            </div>
        </Container>
    );
};
